import React from "react";
import ProjectBySlugPage from "~/src/components/project/pages/ProjectBySlugPage";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

export default function ProjectPage() {
  return (
    <NavbarLayout>
      <ProjectBySlugPage />
    </NavbarLayout>
  );
}
